import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { useUserInviteAccept } from "../hooks/useUser";
import {
  Button,
  Flex,
  Image,
  Loader,
  Stack,
  Text,
  Title,
  Transition,
} from "@mantine/core";
import { TransitionDefault } from "../mantineTheme";
import { FaUsers } from "react-icons/fa";

const Accept = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const invite = queryParams.get("invite");

  const { data, isSuccess, isError, refetch } = useUserInviteAccept(invite);

  useEffect(() => {
    if (invite) {
      refetch({
        invitationId: invite,
      });
    }
  }, [invite]);

  return (
    <Flex
      h="80vh"
      justify="center"
      align="center"
      direction="column"
      ta="center"
    >
      <Transition {...TransitionDefault} mounted={!isSuccess && !isError}>
        {(style) => (
          <Flex style={style} direction="column">
            <Loader color="blue" m="auto" size="xl" />
            <Title order={2} mt="lg">
              Validating invite
            </Title>
          </Flex>
        )}
      </Transition>
      <Transition
        {...TransitionDefault}
        mounted={isSuccess && data?.status == "success"}
      >
        {(style) => (
          <Stack style={style}>
            <Title order={2}>
              Thanks for accepting the invite to join DNA Portal!
            </Title>
            <Text size="lg">
              You can now use your my.audinate/dna.audinate account to login and get access to the DNA portal.
              <br /> If you don&apos;t have an account, please create one at dna.audinate.com to get access.
            </Text>
            <Link to={window.env.REACT_APP_URL_MY_SITE}>
              <Button rightSection={<FaUsers size={14} />} color="red">
                Visit DNA Portal
              </Button>
            </Link>
          </Stack>
        )}
      </Transition>
      <Transition
        {...TransitionDefault}
        mounted={isError || data?.status == "failed"}
      >
        {(style) => (
          <Flex style={style} direction="column">
            <Image src="/processing.gif" m="auto" w="300px" />
            <Title order={2}>Looks like you already accepted the invitation.</Title>
            <Text size="lg">
              Once your account is set up, you will receive a confirmation email with details on how to access the DNA Portal.
              <br /> This can take up to 24 hours, so please bear with us while this happens.
            </Text>
          </Flex>
        )
        }
      </Transition >
    </Flex >
  );
};

export default Accept;
